module.exports = "<app-easel></app-easel>\n"